import React from "react";
import AppointmentCard from "../components/AppointmentCard";
import Footer from "../components/Footer";

const Appointment = () => {
  return (
    <div className="appointment-list">
      <AppointmentCard />
      <Footer />
    </div>
  );
};
export default Appointment;
